import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import IndexSidebar from 'flarum/forum/components/IndexSidebar';
import LinkButton from 'flarum/common/components/LinkButton';
/**
 * Shows at most N top-level tags in the index sidebar before "More…".
 * N is the admin setting `bimmerdock-theme.sidebar_tag_limit`; 0 keeps the
 * flarum/tags default. The tag being viewed always stays visible.
 *
 * Runs after flarum/tags' own navItems extension, which adds the tags as
 * items named `tag{id}` (see composer.json optional-dependencies).
 */
export default function limitSidebarTags() {
  extend(IndexSidebar.prototype, 'navItems', function (items) {
    const limit = app.forum.attribute('bimmerdockThemeSidebarTagLimit') || 0;
    if (limit <= 0 || !('flarum-tags' in flarum.extensions)) return;
    let shown = 0;
    let hidden = 0;
    for (const [key, item] of Object.entries(items.toObject())) {
      if (!/^tag\d+$/.test(key)) continue;
      const attrs = item.content?.attrs;

      // Child tags only appear next to the tag being viewed; leave them be.
      if (attrs?.model?.isChild()) continue;
      if (shown < limit || attrs?.active) {
        shown++;
      } else {
        items.remove(key);
        hidden++;
      }
    }
    if (hidden && !items.has('moreTags')) {
      items.add('moreTags', m(LinkButton, {
        href: app.route('tags')
      }, app.translator.trans('flarum-tags.forum.index.more_link')), -16);
    }
  });
}